import { Mixins, Component, Watch } from "vue-property-decorator";
import { CommitableSlidePanel } from "@/components/slide-panel";
import ListDropdown from "@/components/list-dropdown";
import XInput from '@/components/x-input';
import { debounce } from "lodash";
import { Getter } from 'vuex-class';
import ComCommune from '@/lib/models/com-commune';
import { getCommunes } from '@/lib/services';
import ComDept from '@/lib/models/com-dept';
import { loadingClass } from '@/lib/helpers';

@Component
export default class PanelCom extends Mixins(CommitableSlidePanel) {

  @Getter userDepts;

  protected coms: ComCommune[] = [];
  protected selectedDept: ComDept = null;
  protected filterText: string = "";
  protected fetchDebounced: Function = null;
  protected loading: number = 0;

  created() {
    this.fetchDebounced = debounce(async () => {
      if (this.enoughToFilter) {
        this.loading++;
        this.coms = await getCommunes((this.selectedDept || {} as any).numDept, this.filterText);
        this.loading--;
      } else {
        this.coms = [];
      }
    }, 300);
  }

  get enoughToFilter() {
    return (this.selectedDept && this.filterText?.length > 0) || this.filterText?.length > 1;
  }

  get userDeptsSorted() {
    return [...this.userDepts].sort((a, b) => a.numDept.localeCompare(b.numDept));
  }

  @Watch("selectedDept")
  @Watch("filterText")
  onFiltersChange() {
    this.fetchDebounced();
  }

  onClickCommit(data) {
    this.commit({data});
  }

  onClickCancel() {
    this.cancel();
  }

  mounted() {}

  renderHead() {
    return <span>Sélectionner une commune</span>
  }

  renderBody() {
    return (
      <div class="basic is-flex flex-column">
        <div class="field">
          <div class="control">
            <ListDropdown class="basic"
              data={this.userDeptsSorted}
              vModel={this.selectedDept}
              labelFn={o => `${o.numDept} - ${o.nom}`}
              prompt="Sélectionner un département"/>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <XInput vModel={this.filterText} class="input is-small" placeholder="Filtre"/>
          </div>
        </div>
        <div class={`v-scroll-wrapper async ${loadingClass(this.loading)} is-large`}>
          <table class="table is-full-width is-bordered is-small">
            <thead>
              <tr>
                <th class="sticky-th">INSEE</th>
                <th class="sticky-th">Nom de la commune</th>
                <th class="has-text-centered sticky-th" style="position: sticky">-</th>
              </tr>
            </thead>
            <tbody>
              {this.coms.length > 0 ? (
                this.coms.map(c => (
                  <tr>
                    <td style="vertical-align: middle">{c.numInsee}</td>
                    <td style="vertical-align: middle">{c.nom}</td>
                    <td class="has-text-centered">
                      <button class="button is-small" onClick={() => this.onClickCommit(c)}>Choisir</button>
                    </td>
                  </tr>
                ))
              ) : (
              <tr>
                <td class="has-text-centered has-text-grey-light" colspan={3}>{this.enoughToFilter ? 'Aucun résultat' : 'Précisez la recherche'}</td>
              </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  renderFooter() {
    return (
      <div class="columns is-fluid">
        <div class="column is-9"></div>
        <div class="column is-3 is-flex justify-end">
          <button class="button is-small is-fluid" onClick={this.onClickCancel}>Annuler</button>
        </div>
      </div>
    )
  }
  
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-5137316c/panel-com.tsx" });